const statusLists = [
    { id:"1",name:"一线处理"},
    { id:"2",name:"二线处理"},
];
const companyList = [
    { id:"1",name:"公司1"},
    { id:"2",name:"公司2"},
];
// 发布类型
const categoryList = [
    { id:"1",name:"全发布"},
    { id:"2",name:"包发布"},
    { id:"3",name:"增量发布"},

];
// 变更类别
const categoryList2 = [
    { id:"1",name:"紧急修复"},
    { id:"2",name:"小型发布"},
    { id:"3",name:"重大发布"},

];
//发布分类
const categoryList3 = [
    { id:"1",name:"新项目上线"},
    { id:"2",name:"单项升级"},
    { id:"3",name:"包升级"},
    { id:"4",name:"补丁"},

];

//涉及数据库
const categoryList4 = [
    { id:"1",name:"CMDB配置管理数据库"},
    { id:"2",name:"DHS最终硬件库"},
    { id:"3",name:"DSL最终软件库"},

];

//
const categoryList5 = [
    { id:"1",name:"正常变更"},
    { id:"2",name:"项目上线"},


];



// 优先级
const priorityList = [
    { id:"1",name:"紧急"},
    { id:"2",name:"高"},
    { id:"3",name:"中"},
    { id:"4",name:"低"}
];

// 难易程度
const complexityList = [
    { id:"4",name:"四级:简单的咨询"},
    { id:"3",name:"三级:已知简单故障"},
    { id:"2",name:"二级:需要较多时间解决的故障"},
    { id:"1",name:"一级:未知的故障解决"},
];
const slaList = [
    { id:"1",name:"默认SLA"},
    { id:"2",name:"60分钟SLA"},
    { id:"3",name:"120分钟SLA"},
]


export {
    statusLists
}
